import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageListPickerComponent } from './image-list-picker.component';
import { ImageListOptionComponent } from './image-list-option/image-list-option.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [ImageListPickerComponent, ImageListOptionComponent],
  exports: [ImageListPickerComponent, ImageListOptionComponent],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MatIconModule],
})
export class ImageListPickerModule {}
